module.exports = __webpack_public_path__ + "d6029f1eb50009cfc6d117abb718bc87.png";